import { BoxHTMLProps } from 'reakit';
import { createComponent, createHook } from 'reakit-system';
import { BoxOptions, useBox } from '../Box/Box';
import { cx, ecss } from '../reexports/emotion';

let typographicContentStyles = {
  '&': {
    h1: {
      marginTop: ['h1MarginTop', 'h1BigMarginTop'],
      marginBottom: ['h1MarginBottom', 'h1BigMarginBottom'],
    },
    h2: {
      marginTop: ['h2MarginTop', 'h2BigMarginTop'],
      marginBottom: ['h2MarginBottom', 'h2BigMarginBottom'],
    },
    h3: {
      marginTop: ['h3MarginTop', 'h3BigMarginTop'],
      marginBottom: ['h3MarginBottom', 'h3BigMarginBottom'],
    },
    h4: {
      marginTop: ['h4MarginTop', 'h4BigMarginTop'],
      marginBottom: ['h4MarginBottom', 'h4BigMarginBottom'],
    },
    h5: {
      marginTop: ['h5MarginTop', 'h5BigMarginTop'],
      marginBottom: ['h5MarginBottom', 'h5BigMarginBottom'],
    },
    h6: {
      marginTop: ['h6MarginTop', 'h6BigMarginTop'],
      marginBottom: ['h6MarginBottom', 'h6BigMarginBottom'],
    },
    'p, ul, ol, img': {
      marginTop: '1em',
    },
    'li ul, li ol': {
      my: '0.5em',
    },
    'li + li': {
      marginTop: '0.75em',
    },
    'li li': {
      marginTop: '0.5em',
    },
    'h1, h2, h3, h4, h5, h6, p, ul, ol, li': {
      '&:first-child': {
        marginTop: 0,
      },
      '&:last-child': {
        marginBottom: 0,
      },
    },
    'p + p': {
      marginTop: '1em',
    },
    'p + ul, p + ol': {
      marginTop: '0.75em',
      marginBottom: '1em',
    },
    'ul + p, ol + p': {
      marginTop: '1em',
    },
    'ul ul li + li, ol ol li + li': {
      marginTop: '0.5em',
    },
    'ul ul, ol ol': {
      marginTop: '0.5em',
    },
  },
};

export type TypographicContentOptions = BoxOptions;

let useTypographicContent = createHook<TypographicContentOptions, BoxHTMLProps>(
  {
    name: 'TypographicContent',
    compose: [useBox],
    useOptions(options) {
      return {
        ...options,
        styles: {
          ...typographicContentStyles,
          ...options.styles,
        },
      };
    },
    useProps(options, props) {
      return {
        ...props,
        className: cx(props.className, ecss({ label: 'TextLayout' })),
      };
    },
  }
);

export const TextLayout = createComponent({
  useHook: useTypographicContent,
  as: 'div',
});
